export var FANS_BUY = 'FANS_BUY';
export var FANS_BUY_RESULT = 'FANS_BUY_RESULT';
export var PERFORMANCE_INFO = 'PERFORMANCE_INFO';
export var FANS_BUY_PERFORMANCE = 'FANS_BUY_PERFORMANCE';
export var VERIFY_CODE = 'VERIFY_CODE';